import { jsx } from "react/jsx-runtime";
import { ArrowLeftIcon } from "../../icons/ArrowLeftIcon.js";
import { Button } from "./Button.js";
const BackButton = ({ iconSize = 20, ...props }) => {
  return /* @__PURE__ */ jsx(
    Button,
    {
      "aria-label": "back",
      color: "default",
      variant: "icon",
      sx: {
        width: iconSize * 2,
        height: iconSize * 2
      },
      ...props,
      children: /* @__PURE__ */ jsx(
        ArrowLeftIcon,
        {
          sx: {
            fontSize: iconSize
          }
        }
      )
    }
  );
};
export {
  BackButton
};
//# sourceMappingURL=BackButton.js.map
